<template>
  <GuideWindow :trespassParent="false" customParentId="app-body" class="app-ctrl">
    <template v-slot:systemBarContent>
        <div class="guide-title">
          <div id="dragProtect"></div>
          Reporting Guide
        </div>
        <span @click="closeGuide">
          <i class="far fa-times closeBtn clickable"></i>
        </span>
      </template>
      <template v-slot:content>
        <div id="guide-content">
          <h3 class="fat mt-2 ml-2">{{ $t('Webportal.Guide.Title') }}</h3>

          <div v-for="(section, name) in guideContent" :key="name">
            <div v-if="showSection(name)">
              <button v-b-toggle="`${name}Panel`" class="guideCollapser">
                <span>
                  <font-awesome-icon style="width:25px" :icon="getIconName(name)" />
                  <span class="ml-1">{{guideContent[name].Title}}</span>
                </span>
                <font-awesome-icon style="color:grey; font-size: 12pt" icon="chevron-down" />
              </button>
              <b-collapse :id="`${name}Panel`" accordion="guide-accordion">
                <div class="myCard guideContent">
                  <div class="guideContent" :data-src="`${name}`" v-html="guideContent[name].GuideContent"></div>
                  <div v-if="editOn[name] || addNewOn[name]">
                    <br>
                    <label class="fat" for="test"  >Title:</label>
                    <input type="text" id="test" placeholder="Title" v-model="guideContent[name].Title">
                  </div>
                  <div id="editBtnContainer" v-if="isMSMUser">
                    <!-- Add new localization button -->
                    <button 
                      type="button" 
                      class="btn btn-secondary btn-sm mx-1 my-1" 
                      v-if="!editOn[name] && (locale != guideContent[name].LocalizationId) && !addNewOn[name]" 
                      @click="addLocalization(name)"
                    >
                      <font-awesome-icon style="width:25px" icon="plus" />{{locale}}
                    </button>
                    <!-- edit button -->
                    <button 
                      type="button" 
                      class="btn btn-secondary btn-sm mx-1 my-1" 
                      v-if="!editOn[name] && (locale == guideContent[name].LocalizationId)" 
                      @click='editGuide(name)'
                    >
                      <font-awesome-icon style="width:25px" icon="pencil-alt" />Edit
                    </button>
                    <!-- preview button -->
                    <button 
                      type="button" 
                      class="btn btn-secondary btn-sm mx-1 my-1" 
                      v-if="editOn[name] || addNewOn[name]" 
                      @click="togglePreview(name)"
                    >
                      <font-awesome-icon style="width:25px" :icon="previewOn[name] ? 'eye-slash' : 'eye'" />
                    </button>
                    <!-- save button -->
                    <button 
                      type="button" 
                      class="btn btn-danger btn-sm mx-1 my-1" 
                      v-if="editOn[name]" 
                      :disabled="previewOn[name]"
                      @click='saveGuide(name)'
                    >
                      <font-awesome-icon style="width:25px" icon="save" />Save
                    </button>
                    <!-- save new localization button -->
                    <button 
                      type="button" 
                      class="btn btn-danger btn-sm mx-1 my-1" 
                      v-if="addNewOn[name]" 
                      :disabled="previewOn[name]"
                      @click='saveNewLocalization(name)'
                    >
                      <font-awesome-icon style="width:25px" icon="save" />Save
                    </button>
                    <!-- cancel button -->
                    <button 
                      type="button" 
                      class="btn btn-warning btn-sm mx-1 my-1" 
                      v-if="editOn[name] || addNewOn[name]" 
                      @click='cancelEdit(name)'
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </b-collapse>
            </div>            
          </div>

          <h4 class="fat mt-2 ml-2">{{ $t('Webportal.Guide.Contact') }}</h4>

          <div>
            <!-- guideData.help -->
            <button v-b-toggle="`contactHelp`" class="contactCollapser">
              <font-awesome-icon style="width:25px" icon="life-ring" />
              {{ $t('Webportal.Guide.Help') }}
            </button>
            <b-collapse visible :id="`contactHelp`" accordion="contact-accordion">
              <div class="myCard">
                <span>Support-tel.: +49(0)-251-1 42 35-0 <br> (Mo - Fr, 08:00 - 18:00) <br> <br> E-mail: </span>
                <a v-bind:href="supportEmailHref" v-html="getEmail()"></a>
              </div>
            </b-collapse>

            <!-- guideData.feedback -->
            <!-- <button v-b-toggle="`contactFeedback`" class="contactCollapser">
              <font-awesome-icon style="width:25px" icon="comment-dots" />
              {{ $t('Webportal.Guide.Feedback') }}
            </button>
            <b-collapse :id="`contactFeedback`" accordion="contact-accordion">
              <div class="myCard">
                <span >E-mail: </span>
                <a style="color: #4472c4;" v-bind:href="supportEmailHref" v-html="getEmail()"></a>
              </div>
            </b-collapse> -->
          </div>
        </div>
      </template>
  </GuideWindow>
</template>

<script>
import GuideWindow from "./GuideWindow"
import { i18n } from "@/i18n";
import EventBus from "@/services/EventBus.js";
import AppConfig from "@/mixins/AppConfig-APP_TARGET";
import AuthenticationService from "@/services/AuthenticationService";
import DashboardService from "@/services/DashboardService";

export default {
  name: "Guide",

  mixins: [AppConfig],

  components: {
      GuideWindow
  },

  data() {
    return {
      editOn: {
        cockpit: false,
        focusKpi: false,
        checkExplorer: false,
        mediaExplorer: false,
        rawdata: false,
        frequencies: false,
        aggregatedReports: false,
        actions: false
      },
      previewOn: {
        cockpit: false,
        focusKpi: false,
        checkExplorer: false,
        mediaExplorer: false,
        rawdata: false,
        frequencies: false,
        aggregatedReports: false,
        actions: false
      },
      addNewOn: {
        cockpit: false,
        focusKpi: false,
        checkExplorer: false,
        mediaExplorer: false,
        rawdata: false,
        frequencies: false,
        aggregatedReports: false,
        actions: false
      },
      guideContent: {
        cockpit: null,
        focusKpi: null,
        checkExplorer: null,
        mediaExplorer: null,
        rawdata: null,
        frequencies: null,
        aggregatedReports: null,
        actions: false
      },
      locale: i18n.locale
    };
  },

  methods: {
    addLocalization(section) {
      this.addNewOn[section] = true;
      var array = document.getElementsByClassName("guideContent");
      array.forEach(e => {
        if (e.dataset.src === section) {
          e.innerText = this.guideContent[e.dataset.src].GuideContent;
          e.contentEditable = true;
        };
      });
    },
    async saveNewLocalization(section) {
      this.addNewOn[section] = false;
      var array = document.getElementsByClassName("guideContent");
      var newSection = {
        GuideContent: null,
        GuideSection: section,
        LocalizationId: this.locale,
        Title: this.guideContent[section].Title
      }
      array.forEach(e => {
        if (e.dataset.src === section) {
          newSection.GuideContent = e.innerText;
          newSection.LocalizationId = this.locale;
          e.contentEditable = false;
        };
      });

      try {
        await DashboardService.setGuideContent(newSection)
        .then(() => {
          this.changeGuide();
        })
      } catch (err) {
        console.warn('Error while saving new localization: ' + err);
      }
    },
    showSection(name) {
      switch (name) {
        case "cockpit":
          if (this.hasDashboard() && this.guideContent.cockpit != null) {
            return true;
          } 
          break;
        case "focusKpi":
          if (this.hasComparision() && this.guideContent.focusKpi != null) {
            return true;
          } 
          break;
        case "checkExplorer":
          if (this.hasCheckExplorer() && this.localUserProfile.Permissions.includes('CheckExplorer') && this.guideContent.checkExplorer != null) {
            return true;
          } 
          break;
        case "mediaExplorer":
          if (this.localUserProfile.Permissions.includes('MediaExplorer') && this.guideContent.mediaExplorer != null) {
            return true;
          } 
          break;
        case "rawdata":
          if (this.localUserProfile.Permissions.includes('RawData') && this.guideContent.rawdata != null) {
            return true;
          } 
          break;
        case "frequencies":
          if (this.localUserProfile.Permissions.includes('Frequencies') && this.guideContent.frequencies != null) {
            return true;
          } 
          break;
        case "aggregatedReports":
          if (this.localUserProfile.Permissions.includes('AggregatedReports') && this.guideContent.aggregatedReports != null) {
            return true;
          } 
          break;
        case "actions":
          if ((this.localUserProfile.Permissions.includes('ActionsRevise') || this.localUserProfile.Permissions.includes('ActionsImprove')) && this.guideContent.actions != null) {
            return true;
          } 
          break;
        default:
          break;
      }
      return false;
    },
    getIconName(section) {
      var iconName = "";
      switch (section) {
        case "cockpit":
          iconName = "tachometer-alt";
          break;
        case "focusKpi":
          iconName = "chart-bar";
          break;
        case "checkExplorer":
          iconName = "clipboard-check";
          break;
        case "mediaExplorer":
          iconName = "cloud-download-alt";
          break;
        case "rawdata":
          iconName = "file-excel";
          break;
        case "frequencies":
          iconName = "dice";
          break;
        case "aggregatedReports":
          iconName = "globe-africa";
          break;
        case "actions":
          iconName = "edit";
          break;
        default:
          break;
      }
      return iconName;
    },
    togglePreview(section) {
      var array = document.getElementsByClassName("guideContent");
      array.forEach(e => {
        if(e.dataset.src === section) {
          if (this.previewOn[section] === false) {
            e.innerHTML = e.innerText;
            e.contentEditable = false;
            this.previewOn[section] = true;
          } else {
            e.innerText = e.innerHTML;
            e.contentEditable = true;
            this.previewOn[section] = false;
          }
        };
      });
      this.setUpRouterLink();
    },
    editGuide(value) {
      this.editOn[value] = true;
      var array = document.getElementsByClassName("guideContent");
      array.forEach(e => {
        if (e.dataset.src === value) {
          e.innerText = this.guideContent[e.dataset.src].GuideContent;
          e.contentEditable = true;
        };
      });
    },
    async saveGuide(value) {
      this.editOn[value] = false;
      var array = document.getElementsByClassName("guideContent");
      array.forEach(e => {
        if (e.dataset.src === value) {
          this.guideContent[e.dataset.src].GuideContent = e.innerText;
          e.innerHTML = this.guideContent[e.dataset.src].GuideContent;
          e.contentEditable = false;
        };
      });
      this.setUpRouterLink();

      try {
        await DashboardService.updateGuideContent(this.guideContent[value]);
      } catch (err) {
        console.warn('Error while saving: ' + err);
      }
    },
    cancelEdit(value) {
      this.editOn[value] = false;
      this.previewOn[value] = false;
      this.addNewOn[value] = false;
      var array = document.getElementsByClassName("guideContent");
      array.forEach(e => {
        if(e.dataset.src === value) {
          e.innerHTML = this.guideContent[e.dataset.src].GuideContent;
          e.contentEditable = false;
        };
      });
      this.setUpRouterLink();
    },
    closeGuide() {
      EventBus.$emit("GuideClosed");
    },
    async changeGuide() {
      await this.getGuideData()
      .then(
        setTimeout(() => {
          this.setUpRouterLink();
        }, 500)
      );
    },
    setUpRouterLink() {
      var routeSpans = document.querySelectorAll(".routeSpan");
      routeSpans.forEach((span) => {
        span.addEventListener("click", () => {
          if(span.attributes.dataRouter.value != this.$router.history.current.path) {
            this.$router.push(span.attributes.dataRouter.value);
          }
        });
      });
    },
    async getGuideData() {
      try {
        this.guideContent = {
          cockpit: null,
          focusKpi: null,
          checkExplorer: null,
          mediaExplorer: null,
          rawdata: null,
          frequencies: null,
          aggregatedReports: null,
          actions: null
        };
        await DashboardService.getGuideContent(i18n.locale)
        .then((response) => {
          response.data.forEach(e => {
            var title = e.GuideSection;
            if(e.GuideContent != null) {
              this.guideContent[title] = e;
            } else {
              this.guideContent[title] = null;
            }
          });
        });
      } catch (err) {
        console.warn('Error while loading guide data: ' + err);
      }
    },
    resetBooleans() {
      for (const key in this.editOn) {
        this.editOn[key] = false;
      }
      for (const key in this.previewOn) {
        this.previewOn[key] = false;
      }
      for (const key in this.addNewOn) {
        this.addNewOn[key] = false;
      }
    }
  },
  mounted() {
    this.getGuideData();

    this.changeGuide();
    EventBus.$on("LocalizationChanged", () => {
      this.locale = i18n.locale;
      this.resetBooleans();
      this.changeGuide();
    });
  },
  computed: {
    localUserProfile: function () {
      return AuthenticationService.localUserProfile;
    },
    supportEmailHref() {
      return "mailto:" + this.getEmail();
    },
    isMSMUser: function () {
      return AuthenticationService.isMSMUser;
    },
  },
}
</script>

<style scoped>
#loop-logo {
  height: 20px;
  padding-bottom: 1px;
}
#dragProtect {
  position: absolute;
  width: 50%;
  height: 100%;
}
#editBtnContainer {
  display: flex;
  justify-content: flex-end;
}
.closeBtn {
  height: 1em;
  width: 1em;
  padding: 1px;
  color: black!important;
  border-radius: 10%;
}
.closeBtn:hover {
  background: rgb(201, 201, 201);
  color: black!important;
}
.myCard {
  padding: 8px;
  border-bottom: 1px solid var(--border-color-primary);
}
#guide-content {
  max-height: 80vh;
  overflow-y: auto;
}
.guideCollapser {
  width: 100%;
  height: 50px;
  border: none;
  color: var(--color-primary);
  background: rgba(255, 255, 255, 0);
  font-size: 16pt;
  font-weight: 600;
  border-bottom: 1px solid var(--border-color-primary);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.guideCollapser:hover {
  background: rgba(197, 197, 197, 0.247);
}
.guideCollapser:focus {
  outline: none;
}
.contactCollapser {
  width: 100%;
  height: 35px;
  color: var(--color-primary);
  border: none;
  background: rgba(255, 255, 255, 0);
  font-size: 12pt;
  font-weight: 600;
  border-bottom: 1px solid var(--border-color-primary);
  display: flex;
  justify-content: left;
  align-items: center;
}
.contactCollapser:hover {
  background: rgba(214, 214, 214, 0.247);
}
.contactCollapser:focus {
  outline: none;
}

.fat {
  font-weight: 600;
}
a {
  color: var(--color-primary) !important;
}
a:hover {
  color: var(--color-primary) !important;
}
.guide-title {
  color: var(--color-secondary);
  font-size: 15px;
}
</style>